import { configureStore } from '@reduxjs/toolkit';
import activityReducer from '../features/activity-slice';
import contactsReducer from '../features/contacts-slice';
import medianValuesReducer from '../features/median-values-slice';
import segmentsReducer from '../features/segments-slice';
import chatReducer from '../features/chat-slice';
import threadChatReducer from '../features/thread-chat-slice'
import conversationsReducer from '../features/conversation-slice';
import underlyingDataReducer from '../features/underlying-data-slice';
import favouritesReducer from '../features/favourites-slice';
import tenantReducer from '../features/tenant-slice';

const store = configureStore({
	reducer: {
		activity: activityReducer,
		contacts: contactsReducer,
		medianValues: medianValuesReducer,
		segments: segmentsReducer,
		chat: chatReducer,
		threadChat: threadChatReducer,
		conversations: conversationsReducer,
		underlyingData: underlyingDataReducer,
		favourites: favouritesReducer,
		tenant: tenantReducer
	},
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
